<div *ngIf="loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>

<div class="stepper-container">
  <div class="steps-header complete mb-0" [ngStyle]="getProgressWidth()">
    <!-- If check mark is needed just add completed class in the div below ... -->
    <div class="step" [class.active]="currentStep === 1">
      <div class="step-header" (click)="currentStep = 1">
        <div class="step-number">1</div>
        <div class="step-title">Tests</div>
      </div>
    </div>
    <div class="step" [class.active]="currentStep === 2">
      <div class="step-header" (click)="switchToStep(2)">
        <div class="step-number">2</div>
        <div class="step-title">Tasks</div>
      </div>
    </div>
    <div class="step" [class.active]="currentStep === 3">
      <div class="step-header" (click)="switchToStep(3)">
        <div class="step-number">3</div>
        <div class="step-title">Reports</div>
      </div>
    </div>
  </div>

  <div class="steps-body-wrap">
    <div class="step-body mt-20" [hidden]="currentStep !== 1">
      <app-lnt-form
        (onChangeCountResults)="onChangeCountResults($event)"
        (onLoad)="onLoadTestsForm()"
        [showButtons]="false"
        [allowFlashCall]="true"></app-lnt-form>
    </div>
    <div class="step-body form-summary-container" [hidden]="currentStep !== 2">
      <div class="form-container mt-20">
        <h3>Setup your task</h3>
        <div class="d-flex justify-content-between align-items-start gap-20">
          <form [formGroup]="taskForm" class="w-100">
            <div class="form-row d-flex justify-content-between gap-25">
              <div class="form-group">
                <label class="form-label required">Name </label>
                <input [(ngModel)]="model.title" formControlName="title" type="text" class="form-control" />
                <input-errors [control]="taskForm.controls.title" [service]="validationService"></input-errors>
              </div>
            </div>
            <div class="form-row d-flex justify-content-between gap-25">
              <div class="form-group">
                <label class="form-label">Description </label>
                <textarea [(ngModel)]="model.description" formControlName="description" class="form-control"></textarea>
                <input-errors [control]="taskForm.controls.description" [service]="validationService"></input-errors>
              </div>
            </div>
            <div class="form-row d-flex justify-content-between gap-25">
              <div class="form-group">
                <label class="form-label">Run only once </label>
                <div class="form-check form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.sendOnlyOnce"
                    (ngModelChange)="onChangeSendOnlyOnce()"
                    formControlName="sendOnlyOnce" />
                </div>
              </div>
              <div class="form-group" *ngIf="model.sendOnlyOnce === false">
                <label class="form-label">Run until disabled</label>
                <div class="form-check form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.runUntilDisabled"
                    (ngModelChange)="onChangerunUntilDisabled()"
                    formControlName="runUntilDisabled" />
                </div>
              </div>
              <div class="form-group" *ngIf="model.sendOnlyOnce === false">
                <label class="form-label">Randomize time </label>
                <div class="form-check form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.randomized"
                    (ngModelChange)="onChangeRandomized()"
                    formControlName="randomized" />
                </div>
              </div>
            </div>
          </form>
          <div class="w-100">
            <form [hidden]="model.sendOnlyOnce === false && model.runUntilDisabled === false" [formGroup]="onlyOnceForm">
              <div class="form-group">
                <label class="form-label required">{{ model.runUntilDisabled ? 'Run first batch at ' : 'Run once on ' }} </label>
                <input-date-time
                  [placeholder]="'Start'"
                  [validationService]="validationService"
                  [validator]="startAtValidators"
                  (change)="onStartAtChange($event)"
                  [minDate]="minDateScheduler"></input-date-time>
              </div>
            </form>
            <form [hidden]="model.sendOnlyOnce === true" [formGroup]="periodForm">
              <div *ngIf="model.runUntilDisabled === false" class="form-group date-period mb-10">
                <label class="form-label required">Run From-To </label>
                <span
                  class="icon-help-1 ms-10 text-neutral-n5"
                  tooltip="The start time you set here will also be the time when the first batch is run."></span>
                <input-search-period
                  (change)="onChangeDatePeriod($event)"
                  [start]="model.startAt"
                  [end]="model.finishAt"
                  [timepicker]="true"
                  [ranges]="datePeriodRanges"
                  [customClass]="'flat'"
                  [minDate]="minDateScheduler"></input-search-period>
              </div>
              <div class="alert alert-primary py-0_8 px-1 text-primary-p8">
                <b>Info:</b> The task will be Scheduled in your browser's current time zone. <br />
                - {{ deviceTimezone }}
              </div>
              <div class="form-group days">
                <label class="form-label">Days</label>
                <ul>
                  <li *ngFor="let day of days">
                    <button class="day-btn" [ngClass]="{ unselected: !day.selected }" type="button" (click)="toggleDay(day)">
                      {{ day.label }}
                    </button>
                  </li>
                </ul>
              </div>
              <div class="form-group">
                <label class="form-label">Run tests only between</label>
                <div class="d-flex justify-content-between gap-20">
                  <div class="form-group position-relative run-test-between-input">
                    <i class="icon icon-clock position-absolute text-neutral-n6"></i>
                    <input
                      [(ngModel)]="model.fromHour"
                      (ngModelChange)="updateHour($event)"
                      formControlName="fromHour"
                      type="text"
                      class="form-control"
                      placeholder="From hour (00:00 - 23:59)" />
                    <input-errors [control]="periodForm.controls.fromHour" [service]="validationService"></input-errors>
                  </div>
                  <div class="form-group position-relative run-test-between-input">
                    <i class="icon icon-clock position-absolute text-neutral-n6"></i>
                    <input
                      [(ngModel)]="model.tillHour"
                      (ngModelChange)="updateHour($event)"
                      formControlName="tillHour"
                      type="text"
                      class="form-control"
                      placeholder="Till hour (00:00 - 23:59)" />
                    <input-errors [control]="periodForm.controls.tillHour" [service]="validationService"></input-errors>
                  </div>
                </div>
                <div
                  class="text-error-r2"
                  *ngIf="periodForm.controls.fromHour.valid && periodForm.controls.tillHour.valid && periodForm.errors?.tillHourInvalid">
                  Time interval has to be at least 10 minutes.
                </div>
              </div>
              <div [hidden]="model.randomized" class="form-group">
                <div>
                  <label class="form-label" title="The interval at which new tests will be sent."> Repeat every </label>
                </div>
                <div class="repeat-every-input">
                  <input-duration
                    #repeatEveryControl
                    (change)="onChangeRepeatEvery($event)"
                    [units]="['m', 'h', 'd']"
                    [validationService]="validationService"
                    [modelUnit]="'m'"
                    [modelValue]="60"
                    [require]="true">
                  </input-duration>
                </div>
                <div class="text-error-r2" *ngIf="isFlashCallIntervalTooShort()">
                  Flash call detection requires an interval of at least {{ flashCallMinIntervalMinutes }} minutes.
                </div>
              </div>
              <div *ngIf="model.randomized" class="form-group">
                <label class="form-label required">Repeats per day (randomized task)</label>
                <input
                  [(ngModel)]="model.repeatsPerDayRandomized"
                  formControlName="repeatsPerDayRandomized"
                  type="number"
                  class="form-control"
                  (ngModelChange)="onChangeRepeatsPerDay()" />
                <div class="text-neutral-n6" *ngIf="!isFlashCallMode()">
                  Max number of repeats (one per minute) with the current setup is
                  {{ this.getFromTillMinutesDifference(model.fromHour, model.tillHour) }}
                </div>
                <div class="text-neutral-n6" *ngIf="isFlashCallMode()">
                  Max number of repeats (one per {{ flashCallMinIntervalMinutes }} minutes with flash call detection) with the current setup is
                  {{ getMaxFlashCallRepeatsPerDay() }}
                </div>
                <input-errors [control]="periodForm" [service]="validationService"></input-errors>
                <input-errors [control]="periodForm.controls.repeatsPerDayRandomized" [service]="validationService"></input-errors>
                <div class="text-error-r2" *ngIf="isFlashCallIntervalTooShort() && !periodForm.errors?.allowedRandomizedTasksPerDay">
                  Flash call detection requires an interval of at least {{ flashCallMinIntervalMinutes }} minutes.
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        class="summary-container history w-100 d-flex flex-column"
        *ngIf="scheduleHistory"
        [tooltip]="
          scheduleHistory.countTasks === 0 ? 'To proceed with saving the scheduled task, please make sure that some tests will be triggered.' : ''
        "
        tooltipPlacement="top">
        <div class="flex-grow-1">
          <div class="row" [ngClass]="{ 'text-error-r2': scheduleHistory.countTasks === 0 }">
            <span class="title">Total scheduled task repetitions: </span><span class="value">{{ scheduleHistory.countTasks }}</span>
          </div>
          <div class="row" [ngClass]="{ 'text-error-r2': scheduleHistory.countTests === 0 }">
            <span class="title">Tests per batch: </span>
            <span class="value">{{ testsPerBatch }}</span>
          </div>

          <div class="row d-flex justify-content-start align-items-center" [ngClass]="{ 'text-error-r2': scheduleHistory.countTests === 0 }">
            <span class="title">Total scheduled tests: </span>
            <span class="value px-0">{{ scheduleHistory.countTests }} </span>
            <span
              class="icon icon-warning text-warning-w2 fs-3"
              *ngIf="scheduleHistory.countTests === 'Unlimited' || +scheduleHistory.countTests > 1000"
              tooltip="Please note that this task will be triggering a large number of tests"></span>
          </div>
          <div class="row" *ngIf="scheduleHistory.history.length">
            <span class="title">Schedule summary (the first 10 tasks):</span>
            <div class="value">
              <span *ngFor="let d of scheduleHistory.history" class="date-item">
                {{ d | date: 'dd MMM HH:mm' }}
              </span>
            </div>
          </div>
          <div class="row" *ngIf="model.randomized">
            <span class="title">Task will be triggered at random within each interval of:</span
            ><span class="value">{{ getRandomizedIntervalInMinutes() }} min</span>
          </div>
        </div>
        <div class="alert alert-warning mt-auto border-0" *ngIf="scheduleHistory.countTests === 'Unlimited' || +scheduleHistory.countTests > 1000">
          <span
            ><b>Note:</b> This task will trigger a large number ({{ scheduleHistory.countTests }}) of tests. Please review your settings to ensure the
            number of tests triggered meets your expectations.</span
          >
        </div>
      </div>
    </div>

    <div class="step-body" [hidden]="currentStep !== 3">
      <div class="d-flex h-100">
        <div class="report-container mt-20">
          <div class="report-email-section">
            <h4 class="mb-0_5">Trigger alert only if:</h4>
            <div class="report-email-wrap">
              <div class="report-holder">
                <div class="report-top pt-15 pb-10">
                  <div class="status-holder position-relative" *ngFor="let rule of reportRules.combinationRules; let i = index">
                    <div class="status-index">
                      <span>{{ i + 1 }}</span>
                    </div>

                    <div>
                      <div
                        [dropdown]="dlrDropdownContent"
                        [captureEvents]="true"
                        class="add-btn cp"
                        [class.status-wrap]="rule.messageState"
                        [class.status-add]="!rule.messageState"
                        (onDropdownHide)="saveDlrStatus(rule)"
                        (click)="onClickMessageAddCombinationRule(rule)">
                        @if (!rule.messageState) {
                          <span class="icon-add"></span>
                          DLR status
                          <i class="fas fa-chevron-down ms-0_8"></i>
                        } @else {
                          <span [ngClass]="getIconForStatus(rule.messageState)"></span>
                          <span class="status-text">
                            {{ formatMessageState(rule.messageState) }}
                            <span *ngIf="rule.messageStateWait"> >= {{ formatWait(rule.messageStateWait, rule.messageStateWaitUnit) }}</span>
                          </span>
                          <span class="icon-close cp" (click)="$event.stopPropagation(); removeClickedMessageRule(rule)"></span>
                        }
                      </div>
                      <ng-template #dlrDropdownContent let-dropdown="dropdown">
                        <div class="dropdown-menu status-filter-drop">
                          <div class="status-filter-list">
                            <span class="status-title">Final DLR statuses</span>
                            <div class="status-list-holder">
                              <ng-container *ngFor="let status of reportRules.finalMessageStates">
                                <div class="status-list" (click)="handleDlrCheckbox(status)">
                                  <div class="input-check">
                                    <input class="form-check-input" type="radio" [checked]="status.selected" />
                                  </div>
                                  <span class="icon" [ngClass]="getIconForStatus(status.id)"></span>
                                  <span class="status-text">{{ status.label }}</span>
                                </div>
                              </ng-container>

                              <span class="status-title">Intermediate DLR statuses</span>
                              <ng-container *ngFor="let status of reportRules.intermediateMessageStates">
                                <div class="status-list" (click)="handleDlrCheckbox(status)">
                                  <div class="input-check">
                                    <input class="form-check-input" type="radio" [checked]="status.selected" />
                                  </div>
                                  <span class="icon" [ngClass]="getIconForStatus(status.id)"></span>
                                  <span class="status-text">{{ status.label }}</span>
                                </div>
                                <div class="py-10 px-15" *ngIf="status.selected">
                                  <input-duration
                                    (change)="onChangeStatusWait($event, status)"
                                    [inputClass]="'rounded-input'"
                                    [units]="['s', 'm']"
                                    [modelValue]="getStatusWait(status).wait"
                                    [modelUnit]="getStatusWait(status).unit"
                                    [validationService]="validationService"
                                    [require]="true"
                                    [size]="'sm'"></input-duration>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </div>

                    <span class="and">AND</span>

                    <div>
                      <div
                        [dropdown]="recDropdownContent"
                        [captureEvents]="true"
                        (onDropdownHide)="saveRecStatus(rule)"
                        class="add-btn cp"
                        [class.status-wrap]="rule.testStatus"
                        [class.status-add]="!rule.testStatus"
                        (click)="onClickTestAddCombinationRule(rule)">
                        @if (!rule.testStatus) {
                          <span class="icon-add"></span>
                          Rec.status
                          <i class="fas fa-chevron-down ms-0_8"></i>
                        } @else {
                          <span [ngClass]="getIconForStatus(rule.testStatus)"></span>
                          <span class="status-text">
                            {{ formatTestStatus(rule.testStatus) }}
                            <span *ngIf="rule.testStatusWait"> >= {{ formatWait(rule.testStatusWait, rule.testStatusWaitUnit) }}</span>
                          </span>
                          <span class="icon-close cp" (click)="$event.stopPropagation(); removeClickedTestRule(rule)"></span>
                        }
                      </div>
                      <ng-template #recDropdownContent let-dropdown="dropdown">
                        <div class="dropdown-menu status-filter-drop">
                          <div class="status-filter-list">
                            <span class="status-title">Final Receipt statuses</span>
                            <div class="status-list-holder">
                              <ng-container *ngFor="let status of finalTestStatusOptions">
                                <div class="status-list" (click)="handleReceiptCheckbox(status)">
                                  <div class="input-check">
                                    <input class="form-check-input" type="radio" [checked]="status.selected" />
                                  </div>
                                  <span class="icon" [ngClass]="getIconForStatus(status.id)"></span>
                                  <span class="status-text">{{ status.label }}</span>
                                </div>
                              </ng-container>
                              <span class="status-title">Intermediate Receipt statuses</span>
                              <ng-container *ngFor="let status of reportRules.intermediateTestStatuses">
                                <div class="status-list" (click)="handleReceiptCheckbox(status)">
                                  <div class="input-check">
                                    <input class="form-check-input" type="radio" [checked]="status.selected" />
                                  </div>
                                  <span class="icon" [ngClass]="getIconForStatus(status.id)"></span>
                                  <span class="status-text">{{ status.label }}</span>
                                </div>
                                <div class="py-10 px-15" *ngIf="status.selected">
                                  <input-duration
                                    (change)="onChangeStatusWait($event, status)"
                                    [inputClass]="'rounded-input'"
                                    [units]="['s', 'm']"
                                    [modelValue]="getStatusWait(status).wait"
                                    [modelUnit]="getStatusWait(status).unit"
                                    [validationService]="validationService"
                                    [require]="true"
                                    [size]="'sm'">
                                  </input-duration>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </div>

                    <span class="and">AND</span>

                    <div>
                      <div
                        [dropdown]="repDropdownContent"
                        [captureEvents]="true"
                        (onDropdownHide)="saveExpectedRepetitions(rule)"
                        class="status-wrap repetitions"
                        (click)="onClickExpectedRepetitions(rule)"
                        tooltip="Number of repetitions"
                        tooltipPlacement="top">
                        <span class="status-text">
                          {{ rule.repetitionsTarget === 1 ? 'No reps' : rule.repetitionsTarget + ' reps' }}
                        </span>
                        <i class="fas fa-chevron-down"></i>
                      </div>

                      <ng-template #repDropdownContent let-dropdown="dropdown">
                        <div class="dropdown-menu status-filter-drop expected-rep-dropdown">
                          <div class="status-filter-list">
                            <span class="status-title">Number of reps</span>
                            <div class="status-list-holder">
                              <ng-container *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
                                <div
                                  class="status-list expected-rep-list"
                                  [ngClass]="{
                                    'bg-neutral-n3': repetitionsTarget === i,
                                    'option-disabled': isRepetitionsOptionDisabled(rule, i),
                                  }"
                                  (click)="!isRepetitionsOptionDisabled(rule, i) && onExpectedRepetitionsChange(i)">
                                  <div class="input-check">
                                    <input class="form-check-input" type="radio" [checked]="repetitionsTarget === i" />
                                  </div>
                                  <span class="status-text" [ngClass]="{ 'text-primary': i === repetitionsTarget }">
                                    {{ i === 1 ? 'No' : i }} reps
                                  </span>
                                </div>
                              </ng-container>
                            </div>
                            <!-- No Save button here anymore; saving happens on click-outside via clearDropdowns -->
                          </div>
                        </div>
                      </ng-template>
                    </div>

                    <!-- Uncomment the lines below to add isConsecutive logic -->
                    <!-- <span class="and">AND</span> -->

                    <!-- <div>
                                            <div class="status-wrap" (click)="onClickConsecutive($event, rule)" tooltip="Consecutive repetitions">
                                                <span class="fs-4"
                                                    [ngClass]="rule.isConsecutive ? 'icon-check text-success-s2' : 'icon-close text-error-r3'"></span>
                                                <span class="status-text">
                                                    {{rule.isConsecutive ? 'Yes': 'No'}}
                                                </span>
                                                <i class="fas fa-chevron-down"></i>
                                            </div>

                                            <div class="dropdown-menu show status-filter-drop p-10" *ngIf="rule.isConsecutiveDropdownShow">
                                                <div class="d-flex justify-content-start align-items-start gap-10 mb-15">
                                                    <input type="radio" [checked]="rule.isConsecutive"
                                                        (click)="$event.stopPropagation(); onConsecutiveRepClick(rule, true);">
                                                    <div class="cp" (click)="onConsecutiveRepClick(rule, true)">
                                                        <div class="mb-10">
                                                            <span class="icon-check text-success-s2 fs-4 me-0_8"></span> Yes
                                                        </div>
                                                        <span class="text-neutral-n7">
                                                            We'll send a report only if the test fails with selected conditions several times in a row.
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-start align-items-start gap-10 mb-15">
                                                    <input type="radio" [checked]="!rule.isConsecutive"
                                                        (click)="$event.stopPropagation(); onConsecutiveRepClick(rule, false);">
                                                    <div class="cp" (click)="onConsecutiveRepClick(rule, false)">
                                                        <div class="mb-10">
                                                            <span class="icon-close text-error-r2 fs-4 me-0_8"></span> No
                                                        </div>
                                                        <span class="text-neutral-n7">
                                                            We'll send a report only if the test fails with selected conditions several times in total.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                    <div class="delete-icon ms-10 cp" (click)="removeCombinationReportRule(rule.id)">
                      <i class="far fa-trash-alt fs-3 ms-20"></i>
                    </div>
                  </div>
                </div>

                <div class="py-15">
                  <div class="status-holder">
                    <div class="add-btn dropdown">
                      <a role="button" (click)="onClickAddStatusButton()"> <span class="icon-add"></span> Add Status </a>

                      <a class="ms-20 text-error-r2" role="button" (click)="clearAllStatuses()">
                        <span class="far fa-trash-alt"></span> Remove all statuses
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="noti-email-section" style="border-bottom: 1px solid #e7eaea">
            <div class="d-flex justify-content-start align-items-center gap-10">
              <h4 class="py-15" style="margin: 0">Notifications email</h4>
              <div class="text-primary mx-10 cp" (click)="showEmailField = !showEmailField"><i class="fas fa-plus me-0_5"></i> Add email</div>
            </div>
            <p class="no-email-text text-error-r2" *ngIf="model.reportEmails.length === 0">
              You need to have at least one email here. Click <a class="" (click)="addCurrentUserEmail()">here</a> to add yours.
            </p>
            <form [formGroup]="formEmail" class="pos-relative form">
              <div class="email-holder pb-15" *ngIf="showEmailField" @fieldAnimation>
                <input
                  formControlName="email"
                  type="text"
                  class="form-control"
                  (keyup.enter)="onSubmitEmailForm()"
                  (blur)="onSubmitEmailForm()"
                  placeholder="Type your email and press enter to add it"
                  style="max-width: 800px" />
                <input-errors [control]="formEmail.controls.email" [service]="validationService"></input-errors>
              </div>
              <div class="d-flex justify-content-start align-items-start mb-0_5">
                <div class="d-flex flex-wrap">
                  <div class="pills-btn pills-btn-v2 email-list-item" *ngFor="let email of model.reportEmails">
                    <span class="text" [title]="email">{{ email }}</span>
                    <span class="icon icon-close" (click)="onUnSelectEmail(email)"></span>
                  </div>
                </div>
              </div>
              <p class="notification-label mb-0">Test result reports</p>

              <div class="notificaton-list-wrap py-15">
                <div class="notificaton-list d-flex gap-10 mb-15">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.repetitionReportPerAlertEnabled"
                    [ngModelOptions]="{ standalone: true }" />
                  <div>
                    <div class="label-text cp" (click)="model.repetitionReportPerAlertEnabled = !model.repetitionReportPerAlertEnabled">
                      Instant alert
                    </div>
                    <div class="text-neutral-n7">For each status update that meets your criteria, an immediate alert will be sent to your email.</div>
                  </div>
                </div>
                <div class="notificaton-list d-flex gap-10 mb-10">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.repetitionAlertXlsReportEnabled"
                    [ngModelOptions]="{ standalone: true }" />
                  <div>
                    <div class="label-text cp" (click)="model.repetitionAlertXlsReportEnabled = !model.repetitionAlertXlsReportEnabled">
                      Batch alerts report
                    </div>
                    <div class="text-neutral-n7">
                      After each scheduled batch of tests, you will receive an Excel report via email with test results from the batch which met your
                      criteria.
                    </div>
                  </div>
                </div>
                <div class="notificaton-list d-flex gap-10 mb-10">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.allTestXlsReportEnabled"
                    [ngModelOptions]="{ standalone: true }" />
                  <div>
                    <div class="label-text cp" (click)="model.allTestXlsReportEnabled = !model.allTestXlsReportEnabled">Full batch report</div>
                    <div class="text-neutral-n7">
                      Following each scheduled batch of tests, you will receive an Excel report via email with all the test results from the batch, as
                      soon as TTL expires.
                    </div>
                  </div>
                </div>
              </div>

              <div class="divider mb-15"></div>

              <p class="notification-label mb-0">Coverage alerts</p>
              <div class="notificaton-list-wrap py-15">
                <div class="notificaton-list d-flex gap-10 mb-10">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="model.coverageNotificationEnabled"
                    [ngModelOptions]="{ standalone: true }" />
                  <div>
                    <div class="label-text cp" (click)="model.coverageNotificationEnabled = !model.coverageNotificationEnabled">
                      Network availability alert
                    </div>
                    <div class="text-neutral-n7">While this task is running, get notified when a network it is testing becomes unavailable.</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="noti-email-section">
            <div class="d-flex justify-content-start align-items-center gap-10">
              <h4 class="py-15" style="margin: 0">Callback URL</h4>
              <div class="text-primary mx-10 cp" (click)="showCallbackUrlField = !showCallbackUrlField">
                <i class="fas fa-plus me-0_5"></i> Add URL
              </div>
            </div>
            <div class="hint callback-hint mb-10">
              <span
                >This callback URL is where our server will send reports if any of the reporting rules apply. You can find more technical details in
                our scheduler <a href="https://api-doc.telqtele.com/#callbacks-scheduler-alert" target="_blank"> API documentation</a>.</span
              >
            </div>
            <form [formGroup]="reportsForm" class="pos-relative form">
              <div class="email-holder pb-25" *ngIf="showCallbackUrlField" @fieldAnimation>
                <input formControlName="callbackUrl" type="text" [(ngModel)]="model.callbackUrl" class="form-control" placeholder="Callback url" />
                <input-errors [control]="reportsForm.controls.callbackUrl" [service]="validationService"></input-errors>
              </div>
            </form>
          </div>
        </div>
        <div class="report-note w-100">
          <div class="flex-grow-1">
            <p class="m-20">
              <b>About Reports:</b>This section allows you to combine DLR and Receipt statuses with AND rule, triggering an alert only if both
              conditions of a row are met at the same time.
            </p>
            <div class="report-point-container bg-neutral-n1 m-20 p-15">
              <h5>How it works</h5>
              <div class="d-flex justify-content-start align-items-start gap-10 my-10">
                <span class="number d-flex justify-content-center align-items-center rounded-circle bg-primary-p1 text-primary-p6">1</span>
                <span class="w-100"
                  >On this tab, you can combine DLR and Receipt statuses and Repetitions with AND rule, triggering an alert only if all three
                  conditions of a row are met at the same time.</span
                >
              </div>
              <div class="d-flex justify-content-start align-items-start gap-10 my-10">
                <span class="number d-flex justify-content-center align-items-center rounded-circle bg-primary-p1 text-primary-p6">2</span>
                <span class="w-100">An alert will be triggered if the condition/s in any of the rows are met (“OR” logic between the rows).</span>
              </div>
              <div class="d-flex justify-content-start align-items-start gap-10 my-10">
                <span class="number d-flex justify-content-center align-items-center rounded-circle bg-primary-p1 text-primary-p6">3</span>
                <span class="w-100"
                  >The number of reps determines how many times in a row the specified condition must be met for the report to be sent.</span
                >
              </div>
            </div>
          </div>
          <div class="alert alert-danger mt-auto border-0 mx-20 mb-20 text-error-r2" *ngIf="shouldAlertBeShown()">
            <span
              ><b>Warning:</b> No Statuses that could trigger an alert have been added. <br />
              In this case, no email reports will be sent.</span
            >
          </div>
          <div class="alert alert-danger mt-auto border-0 mx-20 mb-20 text-error-r2" *ngIf="hasFlashCallRuleWithoutFlashCall()">
            <span
              ><b>Warning:</b> The Flash call status is only available with flash call detection. <br />
              Remove it from the statuses or enable flash call detection in the Tests step.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="step-buttons">
    <button type="button" class="btn btn-outline-primary" (click)="onScheduleAfterSave.emit(false)">Cancel</button>
    <div class="button-group d-flex justify-content-end align-items-center">
      <button *ngIf="currentStep !== 1" type="button" class="text-button btn" (click)="prevStep()"><span class="icon-arrow-left"></span> Back</button>
      <button *ngIf="currentStep === 1" [disabled]="!validTab(1)" type="button" class="btn btn-primary" (click)="nextStep()">
        Continue <span class="icon-arrow-right"></span>
      </button>
      <button *ngIf="currentStep === 2" [disabled]="!validTab(2)" type="button" class="btn btn-primary" (click)="nextStep()">
        Continue <span class="icon-arrow-right"></span>
      </button>
      <div *ngIf="currentStep === 3">
        <button [disabled]="!validTab()" (click)="onClickSave()" class="btn btn-primary">{{ getConfirmButtonText() }}</button>
      </div>
    </div>
  </div>
</div>
